import { createApp, nextTick } from "vue";
import { trackPageView } from '@/helpers/analytics/ga.js';
import components from "@/components/components";
import App from "./App.vue";
import "./registerServiceWorker";
// import router from "@/router/router";
import store from "@/store/store";
// declare module 'vue-the-mask/src'
import mask from "vue-the-mask/src/directive";
import moment from "moment-timezone/builds/moment-timezone-with-data.min.js";
import Mitt from "mitt";
import pluralize from "pluralize";
import { createMetaManager } from "vue-meta";
const metaManager = createMetaManager();
// import vMask from '@/directives/mask/directive'
// import axios from 'axios'
import axios from "@/hooks/axios/axios.js";
// import vueTheStorages from 'vue-the-storages'
import pusher from "@/hooks/pusher/pusher.js";
import googleMaps from "@/hooks/googleMaps/googleMaps.js";

import addressText from "@/helpers/address/address.js";
import seekerAddressText from "@/helpers/seeker-address/seekerAddress.js";
import systemDateFormat from "@/helpers/system-date-format/systemDateFormat.js";
import appName from "@/helpers/app-name/appName";
import appSupportEmail from "@/helpers/app-support-email/appSupportEmail";
import appContactNumber from "@/helpers/app-contact-number/appContactNumber";
import systemLocumName from "@/helpers/system-locum-name/systemLocumName";
import { systemCurrency } from "@/helpers/utility/currencyUtils";
import vueTelInput from "@/helpers/vue-tel-input/vueTelInput";
import userRoleConversion from "@/helpers/user-role-conversion/userRoleConversion";
import mobileNumberConversion from "@/helpers/mobile-number-conversion/mobileNumberConversion";
import { messages } from "@/helpers/locales/locales";

import FileHelpers from "@/helpers/file/file";
// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

import modals from "@/modals/modals";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

// import { Userpilot } from 'userpilot'
import { datadogRum } from '@datadog/browser-rum';

//Import loading Script
import { loadScript } from "vue-plugin-load-script";

import Vue3TouchEvents from 'vue3-touch-events';
import OneSignalVue from "onesignal-vue";
import { createHead } from '@unhead/vue';
import employerType from '@/helpers/employer-type/employerType';
import UserbackPlugin from '@userback/vue';
import { initPlausibleFromEnv } from "@/analytics/plausible";
// Import region-specific modules
let router: any;
if (process.env.VUE_APP_REGION === 'US') {
  router = require('@/router/us-router').default;
} else {
  router = require('@/router/au-router').default;
}

const mitt = Mitt();
const head = createHead();
const app = createApp(App)
  .use(components)
  .use(modals, mitt)
  .directive("mask", mask)

  .use(router)
  .use(store)
  .use(axios, { router, store })
  .use(pusher, mitt)
  .use(googleMaps)
  .use(metaManager);
app.use(head);
app.use(Vue3TouchEvents);

const userbackToken = process.env.VUE_APP_USERBACK_TOKEN || '';

  if (userbackToken) {
    const loggedInUser = store.getters.GET_USER_DATA || {};
    const userId = loggedInUser.id || null;
    const userName = loggedInUser.name || "unknown";
    const userEmail = loggedInUser.email || "unknown";
    
    app.use(UserbackPlugin, {
      token: userbackToken,
      user_data: {
        id: userId,
        info: {
          name: userName,
          email: userEmail
        }
      }
    });
  }
  
  
// .use(metaManager, { refreshOnceOnNavigation: true });

// Listen to the window load event to ensure everything is loaded (including JS)
// window.onload = () => {
//   nextTick(() => {
//     const loader = document.getElementById('loader');
//     if (loader) {
//       loader.style.transition = 'opacity 0.5s ease-out';  // Add transition effect
//       loader.style.opacity = '0'; // Fade out the loader
//       setTimeout(() => loader.remove(), 500); // Delay before removing the loader
//     }
//   });
// };

const region = process.env.VUE_APP_REGION || 'AU'; // Default to 'AU' if not set
app.config.globalProperties.$pusher = pusher;
app.config.globalProperties.$moment = moment;
app.provide("$moment", app.config.globalProperties.$moment);
app.config.globalProperties.$mitt = mitt;
app.provide("$mitt", app.config.globalProperties.$mitt);
app.provide('messages', messages[region]);
app.provide("mobileNumberConversion", mobileNumberConversion);
document.documentElement.setAttribute('data-region', region);

app.config.globalProperties.$filters = {
  capitalize(value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },
  pluralize(text, value, options) {

    return pluralize(text, value, options);
  },
  addressText(address) {
    return addressText(address);
  },
  employerType(userData) {
    return employerType(userData);
  },
  seekerAddressText(address) {
    return seekerAddressText(address);
  },
  systemLocumName(capitalizeFirstLetter, capitalizeBothWords) {
    return systemLocumName(capitalizeFirstLetter, capitalizeBothWords);
  },
  systemDateFormat() {
    return systemDateFormat();
  },
  vueTelInput() {
    return vueTelInput();
  },
  appName() {
    return appName();
  },
  userRoleConversion(user) {
    return userRoleConversion(user);
  },
  appContactNumber() {
    return appContactNumber();
  },
  appSupportEmail() {
    return appSupportEmail();
  },
  getFileType(file) {
    const fileHelpers = new FileHelpers();
    return fileHelpers.getFileType(file);
  },
  getFileExt(file) {
    const fileHelpers = new FileHelpers();
    return fileHelpers.getFileExt(file);
  },
  getSystemCurrency() {
    return systemCurrency();
  }
};

app.provide("$filters", app.config.globalProperties.$filters);

const needToShowLogs = process.env.NODE_ENV === 'production';
Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DNS,

  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: needToShowLogs
    }),
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", 'process.env.VUE_APP_BASE_HOST', /^\//],
    }),
  ],
  tracesSampleRate: 1.0,
});

const user = store.getters.GET_USER_DATA;
const userId = user && user.id ? user.id : null;

const louAssistId = process.env.VUE_APP_LOU_ASSIST_ID ?? null;
if (louAssistId && userId) {
  loadScript("//run.louassist.com/v2.5.0-m?id=" + louAssistId)
    .then(() => {
      // Script is loaded, do something
      const userData = {
        name: user.name,
        email: user.email,
        role_id: user.role,
        created_at: user.createdAt
      };

      const lou = (window as any).LOU;
      lou.identify(userId, { ...userData });
      console.log(lou);
    })
}




// UserPilot integration
/*
const userPilotToken = process.env.VUE_APP_USERPILOT_TOKEN !== undefined
               ? process.env.VUE_APP_USERPILOT_TOKEN : '';

if (userPilotToken !== '' && userId !== null) {

  let userData = {
    name: user.name,
    email: user.email,
    role_id: user.role,
    created_at: user.createdAt
  };
  console.log('UserPilot initialization');

  Userpilot.initialize(userPilotToken);
  Userpilot.identify(user.id, userData);
}
*/

// Datadog integration
const dataDogAppId = process.env.VUE_APP_DATADOG_APP_ID !== undefined
  ? process.env.VUE_APP_DATADOG_APP_ID : '';
const dataDogToken = process.env.VUE_APP_DATADOG_TOKEN !== undefined
  ? process.env.VUE_APP_DATADOG_TOKEN : '';
const dataDogSite = process.env.VUE_APP_DATADOG_SITE !== undefined
  ? process.env.VUE_APP_DATADOG_SITE : '';
const dataDogServiceName = process.env.VUE_APP_DATADOG_SERVICE_NAME !== undefined
  ? process.env.VUE_APP_DATADOG_SERVICE_NAME : '';
const dataDogEnvironment = process.env.VUE_APP_DATADOG_ENV !== undefined
  ? process.env.VUE_APP_DATADOG_ENV : '';

if (dataDogAppId && dataDogToken) {
  datadogRum.init({
    applicationId: dataDogAppId,
    clientToken: dataDogToken,
    site: dataDogSite,
    service: dataDogServiceName,
    env: dataDogEnvironment,

    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });

  if (userId !== null) {
    datadogRum.setUser({
      id: userId
    })
  }

  datadogRum.startSessionReplayRecording();
  console.log('DATA DOG')
}

initPlausibleFromEnv();

// const pushNotifications = store.getters.GET_USER_DATA.pushNotifications;

const initOneSignal = () => {
  OneSignal = window.OneSignal || [];
  // if (userId && pushNotifications == null) {
  const data = { push_notifications: 1 };

  // store.dispatch("SAVE_USER_DATA", data);
  /* eslint-disable */

  // }

  OneSignal.push([
    "init",
    {
      appId: process.env.VUE_APP_ONE_SIGNAL_API_KEY,
      subdomainName: "ourtutorial",
      autoRegister: true,
      promptOptions: {
        /* These prompt options values configure both the HTTP prompt and the HTTP popup. */
        /* actionMessage limited to 90 characters */
        actionMessage:
          "We'd like to show you notifications for the latest news.",
        /* acceptButtonText limited to 15 characters */
        acceptButtonText: "ALLOW",
        /* cancelButtonText limited to 15 characters */
        cancelButtonText: "NO THANKS",
      },
    },
  ]);
  function subscribe() {
    // OneSignal.push(["registerForPushNotifications"]);
    OneSignal.push(["registerForPushNotifications"]);
  }
  function unsubscribe() {
    OneSignal.setSubscription(true);
  }

  var OneSignal = OneSignal || [];
  OneSignal.push(function () {
    /* These examples are all valid */
    // Occurs when the user's subscription changes to a new value.
    OneSignal.on("subscriptionChange", function (isSubscribed) {
      OneSignal.sendTag("user_id", userId, function (tagsSent) {
        // Callback called when tags have finished sending
        console.log("Tags have finished sending!");
      });
    });

    var isPushSupported = OneSignal.isPushNotificationsSupported();
    if (isPushSupported) {
      // Push notifications are supported
      OneSignal.isPushNotificationsEnabled().then(function (isEnabled) {
        if (isEnabled) {
          console.log("Push notifications are enabled!");
        } else {
          OneSignal.showHttpPrompt();
          console.log("Push notifications are not enabled yet.");
        }
      });
    } else {
      console.log("Push notifications are not supported.");
    }
  });
};

if (userId) {
  initOneSignal();
}


router.afterEach((route) => {
  // Userpilot.reload();
  trackPageView(route.fullPath, String(route.name ?? route.path));
});

router.isReady().then(() => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }
  app.mount("#app");
  // Use nextTick to ensure DOM updates are complete before removing the loader
  nextTick(() => {
    const loader = document.getElementById('loader');
    if (loader) {
      loader.style.opacity = '0'; // Fade out the loader
      setTimeout(() => loader.remove(), 500); // Remove after fade-out
    }
  });

});
